import React from 'react'
import { withNavigation } from '../templates/navigation/withNavigation'
import LinkList from '../templates/link-list/LinkList';

const LinkPage = () => <LinkList />

export default withNavigation({ title: 'Link' })(LinkPage)



// WEBPACK FOOTER //
// ./src/components/pages/LinkPage.js